// src/Login/Login.js

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';
import { useAuth } from '../../hooks/useAuth';
import { useToast } from '../../components/Toast/ToastProvider';
import './Login.css';

function Login() {
    const navigate = useNavigate();
    const { login } = useAuth();
    const { showToast } = useToast();
    const [usuario, setUsuario] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    // Si llegamos aquí por una sesión expirada (interceptor 401 con recarga),
    // avisamos al usuario.
    useEffect(() => {
        if (sessionStorage.getItem('sesion_expirada')) {
            sessionStorage.removeItem('sesion_expirada');
            showToast('Tu sesión expiró. Por favor, inicia sesión nuevamente.', 'warning', 7000);
        }
    }, [showToast]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        setError(null);
        setIsLoading(true);

        try {
            const { data } = await api.post('/login', { username: usuario, password });

            // Guarda token de sesión SAP + datos del usuario.
            login(data.sessionToken, data.usuario);
            navigate('/dashboard');
        } catch (err) {
            setError(
                err.response?.data?.error ||
                'No se pudo conectar con el servidor.'
            );
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="login-container">
            <div className="login-card">
                <div className="login-header">
                    <img src="/GC.png" alt="Logo Codylsa" className="login-logo" />
                    <h2>Iniciar Sesión</h2>
                    <p>Ingresa tus credenciales para acceder</p>
                </div>
                
                <form onSubmit={handleSubmit} className="login-form">
                    <div className="mb-3">
                        <label htmlFor="userInput" className="form-label">Usuario SAP B1</label>
                        <input 
                            type="text"
                            className="form-control" 
                            id="userInput"
                            placeholder="Ingrese su usuario"
                            value={usuario}
                            onChange={(e) => setUsuario(e.target.value)}
                            required 
                        />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="passwordInput" className="form-label">Contraseña</label>
                        <input 
                            type="password" 
                            className="form-control" 
                            id="passwordInput"
                            placeholder="••••••••"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required 
                        />
                    </div>
                    
                    {error && (
                        <div className="alert alert-danger" role="alert">{error}</div>
                    )}
                    
                    <button type="submit" className="btn btn-primary w-100" disabled={isLoading}>
                        {isLoading ? 'Ingresando...' : 'Ingresar'} 
                        {!isLoading && <i className="bi bi-box-arrow-in-right ms-2"></i>}
                    </button>
                </form>
            </div>
        </div>
    );
}

export default Login;
